import { Controller } from "stimulus"

// A convenience file input that is NOT part of the form submission (no `name`
// attribute) — it mirrors whatever file is picked into the real, name-bearing
// file input elsewhere on the page, so the same attachment can be uploaded
// from more than one spot in a multi-step form without two inputs fighting
// over the same submitted param.
export default class extends Controller {
  static targets = ["input", "name"]
  static values = { targetSelector: String }

  change() {
    const file = this.inputTarget.files[0]

    if (this.hasNameTarget) {
      this.nameTarget.textContent = file ? file.name : (this.nameTarget.dataset.emptyText || "")
    }

    if (!file) return

    const realInput = document.querySelector(this.targetSelectorValue)
    if (!realInput) return

    const transfer = new DataTransfer()
    transfer.items.add(file)
    realInput.files = transfer.files
    realInput.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
